import { dbisHttp, wmsHttp, bigDataHttp,otmsHttp,bmsWebHttp,bfsUserWebHttp } from '@/utils/http/index.js'

/**
 * 订单数相关
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16361
 */
export function getOrderCnt(data) {
  return dbisHttp.post('/dashboard/oms/u_order_cnt', data)
}

/**
 * 门店下单数（运输）及环比
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16395
 */
export function getOrderCntRatio(data) {
  return dbisHttp.post('/dashboard/oms/d_order_cnt_ratio', data)
}

/**
 * 预估运费及环比
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16399
 */
export function getTransportCost(data) {
  return dbisHttp.post('/dashboard/oms/transport_cost_ratio', data)
}

/**
 * 签收订单数
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16401
 */
export function getSignOrder(data) {
  return dbisHttp.post('/dashboard/oms/sign_order_cnt', data)
}

/**
 * 异常监控
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16403
 */
export function getExceptionStats(data) {
  return dbisHttp.post('/dashboard/oms/exception_stats', data)
}

/**
 * 温度异常监控
 * https://yapi.ops.yunlizhi.cn/project/507/interface/case/587
 */
 export function getTemperatureExceptionStats(data) {
  return dbisHttp.post('/dashboard/oms/temperature_exception_stats', data)
}

/**
 * U订单数统计(按天展示)
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16405
 */
export function getOrderCntByDay(data) {
  return dbisHttp.post('/dashboard/oms/u_order_cnt_by_day', data)
}

/**
 * 门店订单排行
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16445
 */
export function getStationOrderCnt(data) {
  return dbisHttp.post('/dashboard/oms/station_order_cnt_rank', data)
}

/**
 * 货品库存分析
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16353
 */
export function goodsStock(data) {
    return dbisHttp.request({
        url: '/dashboard/wms/goods_stock_analysis',
        method: 'post',
        data,
    })
}

/**
 * 运费占比
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16447
 */
export function transportCost(data) {
    return dbisHttp.request({
        url: '/dashboard/oms/transport_cost_distribute',
        method: 'post',
        data,
    })
}

/**
 * 运费占比
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16449
 */
export function lineOrder(data) {
    return dbisHttp.request({
        url: '/dashboard/oms/line_order_cnt_top10',
        method: 'post',
        data,
    })
}

/**
 * 货品流向
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16453
 */
export function goodsStation(data) {
    return dbisHttp.request({
        url: '/dashboard/oms/goods_to_station_top10',
        method: 'post',
        data,
    })
}

/**
 * 货品运输
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16455
 */
export function transportSku(data) {
    return dbisHttp.request({
        url: '/dashboard/oms/transport_sku_top10',
        method: 'post',
        data,
    })
}

/**
 * 容器库存分页查询
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/15199
 */
export function containerStock(data, params) {
    return wmsHttp.request({
        url: '/warehouse_management_system/stock/container_stock/page',
        method: 'post',
        data,
        params
    })
}

/**
 * 库存批次导出
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/22317
 */
export function exportStockByBatch(data) {
  return otmsHttp.post('/data/export/stock_by_batch', data)
}

/**
 * 轨迹预警订单统计
 * https://yapi.ops.yunlizhi.cn/project/511/interface/api/17069
 */
 export function getOrderAlarm(data) {
  return bigDataHttp.post('/api/web/OMS/getUOrderAlarmCount', data)
}

/** 
 * 货主（客户）对账
 * https://yapi.ops.yunlizhi.cn/project/373/interface/api/17185
 */
 export function incomeMasterCustomerPage(data, params) {
  return bmsWebHttp.request({
      url: '/audit_web/income_master/customer/page',
      method: 'post',
      data,
      params
  })
}


/**
 * 货主（客户）对账
 * https://yapi.ops.yunlizhi.cn/project/373/interface/api/17187
 */
 export function incomeMasterCustomerDetailPage(data, params) {
  return bmsWebHttp.request({
      url: '/audit_web/income_master/customer/detail/page',
      method: 'post',
      data,
      params
  })
}

/**
 * 费目明细
 * https://yapi.ops.yunlizhi.cn/project/373/interface/api/17303
 */
 export function audincomebillDetailOrderCostValue(data) {
  return bmsWebHttp.request({
      url: `/audit_web/audincomebilldetail/orderCostValue/${data}`,
      method: 'get',
  })
}


/**
 * 账单批量导出
 *
 */
 export function customerBillExport(data) {
  return otmsHttp.request({
      url: `/customer/bill/export`,
      method: 'post',
      data,
  })
}

/**
 * 库存报表查询
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/17067
 */
 export function stockHistoryReport(data,params) {
  return wmsHttp.request({
      url: `/warehouse_management_system/stock_history_report/page`,
      method: 'post',
      data,
      params
  })
}

/**
 * 进销存报表导出
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/17823
 */
 export function stockHistoryExport(data,params) {
  return otmsHttp.request({
      url: `/data/export/stock_history`,
      method: 'post',
      data,
      params
  })
}

/**
 * 货主货品库存分页查询
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/15009
 */
 export function shipperGoodsStock(data, params) {
  return wmsHttp.request({
      url: '/warehouse_management_system/shipper_goods_stock/page',
      method: 'post',
      data,
      params
  })
}

/**
 * 货主货品库存导出
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/15009
 */
 export function shipperGoodsStockExport(data, params) {
  return otmsHttp.request({
      url: '/data/export/stock',
      method: 'post',
      data,
      params
  })
}

// 根据账号查询组织列表
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/9448
export function projectList(data) {
  return bfsUserWebHttp.post({
      url: '/bfs-user/account_org/organization/list',
      method: 'post',
      data,
  })
}

/**
 * 获取配置:
 * https://yapi.ops.yunlizhi.cn/project/66/interface/api/14715
 */
 export function getConfig(data) {
  return otmsHttp.request({ url: '/tms_plus/config/list', method: 'post', data });
}
